import { Injectable } from "@angular/core";
import { EnvironmentConfig } from "../core";

declare var environment: EnvironmentConfig;

@Injectable({
  providedIn: "root",
})
export class LocalStorageService {
  constructor() {}

  get(key: any, useSessionStorage: boolean = false) {
    let storageToUse = localStorage;
    if (useSessionStorage) {
      storageToUse = sessionStorage;
    }

    const storageValue = storageToUse.getItem(environment.clientId + "." + key);
    return storageValue ? JSON.parse(storageValue) : null;
  }

  set(key: any, value: any, useSessionStorage: boolean = false) {
    let storageToUse = localStorage;
    if (useSessionStorage) {
      storageToUse = sessionStorage;
    }

    const data = JSON.stringify(value);
    if (data) {
      storageToUse.setItem(environment.clientId + "." + key, data);
    }
  }

  remove(key: any, useSessionStorage: boolean = false) {
    let storageToUse = localStorage;
    if (useSessionStorage) {
      storageToUse = sessionStorage;
    }

    storageToUse.removeItem(environment.clientId + "." + key);
  }

  clearAll() {
    localStorage.clear();
  }
}

export const LocalStorageKeys = {
  CartId: "cart-id",
  InspectionWelcome: "welcome",
  /** Last `/equipment-rentals…` (or for-sale/map) URL the user viewed; used by cart "Add more machines". */
  LastSearchResultsUrl: "last-search-results-url",
  /** Cart id the anonymous "10% off for your phone number" offer was last shown for (shown once per cart). */
  AnonymousDiscountOfferCartId: "anonymous-discount-offer-cart-id",
};
